import { instance } from "api/apiBase";
import { User } from "views/settings-users/types";

export const assigneeApi = {
  getAssignees: async (params?: {
    search?: string;
    property_id?: number;
    // Opt-in: only users eligible to conduct showings at `property_id`.
    // Requires `property_id`; omit it everywhere lead assignment is meant.
    showing_eligible?: boolean;
  }): Promise<User[]> => {
    const { data } = await instance.get<User[]>(
      `/portal/v1/boom_crm/assignees`,
      { params }
    );
    return data;
  }
};
